/* Etiquetas multiidoma en castellano. */
export default {
  "waitingLayer.loading": "cargando",
  "waitingLayer.timeWarning.delay": "Estamos tardando más de lo esperado.",
  "waitingLayer.timeWarning.wait": "Por favor, mantente a la espera.",
};
